function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-piscine");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-piscine",
  fill: "#5AC8FA"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 3,
  y: 3,
  width: 24,
  height: 24
})));

const SvgIco30Piscine = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Piscine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-piscine.d9578391.svg";
export { ForwardRef as ReactComponent };